/**
 * Screen 10 - Tell someone about your goal.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';

function Accountability({
  emailAccountableResults,
  nextStep,
  paragraphData,
  previousStep,
  resultAccountableEmail,
  resultAccountableName,
  resultAccountableText,
  resultUserName,
  setResult,
}) {
  const {
    fieldTitle,
    fieldText,
  } = paragraphData;
  const emailAndSend = () => {
    emailAccountableResults();
    nextStep();
  };
  return (
    <div
      className={classnames({
        'goal--step-ten': true,
      })}
    >
      <h4
        dangerouslySetInnerHTML={{
          __html: fieldTitle[0] ? (fieldTitle[0].value + ' (optional)') : '',
        }}
      />
      <div
        className={classnames({
          description: true,
        })}
        dangerouslySetInnerHTML={{
          __html: fieldText[0].value,
        }}
      />
      <div>
        <div>
          <input
            defaultValue={resultAccountableName}
            onChange={evt => setResult({
              resultAccountableName: evt.target.value,
            })}
            placeholder="Name"
            type="text"
          />
        </div>
        <div>
          <h5>
            Notify this person
          </h5>
          <input
            defaultValue={resultAccountableEmail}
            onChange={evt => setResult({
              resultAccountableEmail: evt.target.value,
            })}
            placeholder="Your friend's email"
            type="email"
          />
        </div>
        {resultAccountableEmail &&
          <div className="email--message">
            <h5>
              Include a message to this person
            </h5>
            <textarea
              defaultValue={resultAccountableText}
              onChange={evt => setResult({
                resultAccountableText: evt.target.value,
              })}
            />
          </div>
        }
        <div>
          <h5>
            What&apos;s your name?
          </h5>
          <div
            style={{
              marginTop: '10px',
            }}
          >
            We&apos;ll include this on the notification email.
          </div>
          <input
            defaultValue={resultUserName}
            onChange={evt => setResult({
              resultUserName: evt.target.value,
            })}
            placeholder="Your name"
            type="text"
          />
        </div>
      </div>
      <ButtonPrevious previousStep={previousStep} />
      <ButtonNext
        buttonText={resultAccountableEmail ? 'Send and Continue' : 'Next'}
        nextStep={emailAndSend}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Step 10 of 10
      </div>
    </div>
  );
}

Accountability.propTypes = {
  emailAccountableResults: PropTypes.func,
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  resultAccountableEmail: PropTypes.string,
  resultAccountableName: PropTypes.string,
  resultAccountableText: PropTypes.string,
  resultUserName: PropTypes.string,
  setResult: PropTypes.func,
};

export default Accountability;



// WEBPACK FOOTER //
// js/src/goals/Accountability.js